import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'bootstrap'
import App from './App.vue'
import router from './router'
import { authPlugin } from '@/auth'
import { hasPermission } from '@/auth/permissions'
import "@/styles/equivate.scss"

// font-awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faPlus, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// data table
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'

const pinia = createPinia()
const app = createApp(App)

library.add(faCheck, faPlus, faUser)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('EasyDataTable', Vue3EasyDataTable)

app.use(pinia)
app.use(router)
app.use(authPlugin, { router })

// Legacy two-arg permission helper: this.$userCan('company', 'delete')
// Maps to the new single-string format: 'company:delete'
app.config.globalProperties.$userCan = (resource, action) => hasPermission(`${resource}:${action}`)

router.beforeEach((to, from, next) => {
	if (to.meta && to.meta.title) {
		document.title = to.meta.title
	} else {
		document.title = 'Equivate'
	}
	next()
})

app.mount('#app')
